import type { PublicUser } from "../api/auth.js";

/** Stable permission identity; narrowing access must never reuse wider cached data. */
export function analyticsAccessKey(user: PublicUser | null): string {
  if (!user) return "signed-out";
  return JSON.stringify([
    user.id, user.tenantId, user.role,
    user.accessibleStores?.mode === "all" ? "all" : [...(user.accessibleStores?.storeIds ?? [])].sort(),
  ]);
}
